import React from "react";
import "./HairBotoxWhat.css";
const HairBotoxWhat = () => {
  return (
    <div className="hairBotoxWhat">
      <h2>What is Hair Botox?</h2>
      <p>
        Hair Botox is a deep conditioning treatment designed to repair damaged
        hair, eliminate frizz, and restore shine and softness. Despite its name,
        Hair Botox does not contain Botulinum Toxin, the ingredient used in
        cosmetic Botox injections. Instead, it is named for its rejuvenating
        effects, akin to how cosmetic Botox can refresh the appearance of the
        skin. The treatment is enriched with essential nutrients, proteins,
        amino acids, and natural ingredients that work together to nourish and
        strengthen the hair from within.
      </p>
      <p>The formulation of Hair Botox typically includes a combination of :</p>
      <ul>
        <li>
            <span> Collagen Complex:</span> Collagen is a protein that provides
            strength and elasticity to the hair. It helps in repairing damaged
            hair fibers and promoting healthy hair growth.
        </li>
        <li>
          <span>Vitamins and Antioxidants:</span> Vitamins such as E, B5, and C,
          along with antioxidants, protect the hair from environmental damage
          and free radicals, keeping it healthy and vibrant.
        </li>
        <li>
          <span>Natural Oils:</span> Oils like argan oil, jojoba oil, and
          coconut oil deeply moisturize and hydrate the hair, reducing dryness
          and brittleness.
        </li>
        <li>
          <span>Amino Acids and Keratin:</span> Amino acids and keratin are
          essential components of the hair's structure. They help in rebuilding
          and fortifying the hair, making it more resilient to damage.
        </li>
      </ul>
    </div>
  );
};

export default HairBotoxWhat;
